var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide"}},[_c('div',{staticClass:"sidebar-panel",class:{ active: _vm.isPanelOpen }},[_c('div',{attrs:{"id":"sidebar-arrow"},on:{"click":function($event){$event.preventDefault();return _vm.togglePanel.apply(null, arguments)}}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }